//import { triggerBase64Download } from 'react-base64-downloader';
import React from 'react';
import { adjuntoService } from '../_services';
import { utilActions } from '../_actions';
import Descargador from './Descargardor';
import Resizer from "react-image-file-resizer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isBrowser, isMobile } from "react-device-detect";

export default class MiUploadArchivo extends React.Component {

	state = {
		videoError: undefined
	}

    /** El padre puede pasar `onArchivoCargado` para grabar la foto apenas se elige. */
    avisarCargado = () => {
        const {onArchivoCargado, tipo} = this.props;
        if (onArchivoCargado) onArchivoCargado(tipo);
    }

    parsearFile = (event) =>{
      let {values, tipo, setFieldValue, arrayHelpers} = this.props;

      if(!!event.currentTarget.files[0]){

		const file = event.currentTarget.files[0];
		const index = utilActions.getIndexDocumento(tipo, values.imagenes);
		try {
			const isVideo = file.type.startsWith('video');
			
			if(isVideo){
				var video = document.createElement('video');
				video.preload = 'metadata';

				const newThis = this;
			
				video.onloadedmetadata = function () {			 
					window.URL.revokeObjectURL(video.src);
					if(video.duration >10){
						newThis.setState({videoError: 'El video no puede superar los 10 segundos'})
					}else{
						newThis.setState({videoError: undefined})
						let reader = new FileReader();

						// Convert the file to base64 text
						reader.readAsDataURL(file);

						// on reader load somthing...
						reader.onload = () => {
							// Make a fileInfo Object
							let docu={
								id:undefined, base64:reader.result, tipo:tipo, nombre:file.name, descripcion:file.name, temp:true, type: file.type
							}
							if(index===undefined)arrayHelpers.push(docu);
							else {
								setFieldValue(`imagenes[${index}].id`,undefined);
								setFieldValue(`imagenes[${index}].base64`,reader.result);
								setFieldValue(`imagenes[${index}].nombre`,file.name);
								setFieldValue(`imagenes[${index}].descripcion`,file.name);
								setFieldValue(`imagenes[${index}].temp`,true);
								setFieldValue(`imagenes[${index}].type`,file.type);
							}
							newThis.avisarCargado();
						};
					}
				};
			
				video.src = URL.createObjectURL(file);
			}else{
				Resizer.imageFileResizer(
					file,
					1080,
					1080,
					"JPEG",
					50,
					0,
					(base64String) => {
						
						let docu={
							id:undefined, base64:base64String, tipo:tipo, nombre:file.name, descripcion:file.name, temp:true, type: file.type
						}
						if(index===undefined)arrayHelpers.push(docu);
						else {
							setFieldValue(`imagenes[${index}].id`,undefined);
							setFieldValue(`imagenes[${index}].base64`,base64String);
							setFieldValue(`imagenes[${index}].nombre`,file.name);
							setFieldValue(`imagenes[${index}].descripcion`,file.name);
							setFieldValue(`imagenes[${index}].temp`,true);
							setFieldValue(`imagenes[${index}].type`,file.type);
						}
						this.avisarCargado();
					},
					"base64",
				);
			}

		 
		  } catch (err) {
			console.log(err);
		  }
		}
    }

    render(){

        let {values, tipo, setFieldValue, arrayHelpers, idUnique} = this.props;

        return (
         <>
              <div className='form-control--upload'>
				{values.imagenes[utilActions.getIndexDocumento(tipo, values.imagenes)]?
						<Descargador className='form-textUpload' nombre={utilActions.definirNombreArchivo(tipo, idUnique)} documento={values.imagenes ? values.imagenes[utilActions.getIndexDocumento(tipo, values.imagenes)]:undefined}>
						</Descargador>
						
							:'Seleccione una imagen'}

					<label htmlFor={idUnique+'f'} className=''>
					<div className="button" data-type='complementary-smallest'><FontAwesomeIcon icon="fas fa-file-upload" /></div>

					<input className="d-none" id={idUnique+'f'} name={idUnique+'f'} type="file" accept="image/png, image/jpeg, video/*" onChange={(event) => {
						this.parsearFile(event)}}  />
					</label>

					{isMobile && <label htmlFor={idUnique+'a'} className=''>
						<div className="button" data-type='complementary-smallest'><FontAwesomeIcon icon="fa-solid fa-camera" /></div>

						<input  className="d-none" id={idUnique+'a'} name={idUnique+'a'} type="file" accept="image/png, image/jpeg" capture="environment" onChange={(event) => this.parsearFile(event)}  />
					</label>}					
              </div>
			  {this.state.videoError && 
				<div>
					{this.state.videoError}
				</div>}


        </>
     )};
 }
